import { ROUTES_PREFIXES } from 'const';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as NoNgSidebarImage } from 'assets/icons/no_ng_sidebar.svg';

const SidebarLink = ({ slug, title, image, thumbnailAlt, onClick, bgColor }) => {
  const url = `${ROUTES_PREFIXES.NG}/${slug}`;
  return (
    <NavLink
      className={({ isActive }) =>
        isActive ? 'sidebar-list-item sidebar-list-item__active' : 'sidebar-list-item'
      }
      to={url}
      onClick={onClick}
      style={{ backgroundColor: bgColor }}>
      <div className="sidebar-main-items">
        <div>{title}</div>
        {image ? (
          <img loading="lazy" className="sidebar-image" src={image} width="32" alt={thumbnailAlt || title} />
        ) : (
          <NoNgSidebarImage width="32" height={32} />
        )}
      </div>
    </NavLink>
  );
};

export default SidebarLink;
